import React, { useState, useEffect } from 'react';
import { ListGroup, ListGroupItem, Container, Row, Col, Form, Badge, Pagination, FormControl, Button, FormGroup, Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useQuery, QueryClient, QueryClientProvider } from 'react-query';
import { connect, useDispatch, useSelector, Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { createReducer } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var toConsumableArray = function toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
    return arr2;
  } else {
    return Array.from(arr);
  }
};
var Header = function Header(_ref) {
  var header = _ref.header;
  return React.createElement(ListGroup, null, React.createElement(ListGroupItem, null, React.createElement(Container, {
    fluid: true
  }, React.createElement(Row, null, [].concat(toConsumableArray(header)).map(function (head) {
    return React.createElement(Col, {
      sm: head[0]
    }, React.createElement('strong', null, head[1]));
  })))));
};
Header.propTypes = {
  header: PropTypes.arrayOf(PropTypes.shape({
    colWidth: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired
  })).isRequired
};
var getActivePageNum = function getActivePageNum(store) {
  return store ? store.activePageNum : 0;
};
var getNumItemsPerPage = function getNumItemsPerPage(store) {
  return store ? store.numItemsPerPage : 10;
};
var getTotalNumItems = function getTotalNumItems(store) {
  return store ? store.totalNumItems : 0;
};
var getMaxNumPagesToDisplay = function getMaxNumPagesToDisplay(store) {
  return store ? store.maxNumPagesToDisplay : 5;
};
var TotNumItems = function TotNumItems(_ref) {
  var totNumItems = _ref.totNumItems;
  return React.createElement('div', null, React.createElement(Form.Label, null, 'total number of items:'), ' ', React.createElement(Badge, {
    variant: 'secondary'
  }, totNumItems));
};
TotNumItems.propTypes = {
  totNumItems: PropTypes.number.isRequired
};
var mapStateToProps$3 = function mapStateToProps(state) {
  return {
    totNumItems: getTotalNumItems(state)
  };
};
var TotNumItems$1 = connect(mapStateToProps$3, {})(TotNumItems);
var SET_NUM_ITEMS_PER_PAGE = 'SET_NUM_ITEMS_PER_PAGE';
var SET_TOTAL_NUM_ITEMS = 'SET_TOTAL_NUM_ITEMS';
var SET_MAX_NUM_PAGES_TO_DISPLAY = 'SET_MAX_NUM_PAGES_TO_DISPLAY';
var GO_TO_NEXT_PAGE = 'GO_TO_NEXT_PAGE';
var GO_TO_PREV_PAGE = 'GO_TO_PREV_PAGE';
var GO_TO_FIRST_PAGE = 'GO_TO_FIRST_PAGE';
var GO_TO_LAST_PAGE = 'GO_TO_LAST_PAGE';
var GO_TO_PAGE = 'GO_TO_PAGE';
var setNumItemsPerPage = function setNumItemsPerPage(numItemsPerPage) {
  return {
    type: SET_NUM_ITEMS_PER_PAGE,
    payload: {
      numItemsPerPage: numItemsPerPage
    }
  };
};
var setMaxNumPagesToDisplay = function setMaxNumPagesToDisplay(maxNumPagesToDisplay) {
  return {
    type: SET_MAX_NUM_PAGES_TO_DISPLAY,
    payload: {
      maxNumPagesToDisplay: maxNumPagesToDisplay
    }
  };
};
var setTotalNumItems = function setTotalNumItems(totalNumItems) {
  return {
    type: SET_TOTAL_NUM_ITEMS,
    payload: {
      totalNumItems: totalNumItems
    }
  };
};
var goToNextPage = function goToNextPage() {
  return {
    type: GO_TO_NEXT_PAGE
  };
};
var goToPrevPage = function goToPrevPage() {
  return {
    type: GO_TO_PREV_PAGE
  };
};
var goToFirstPage = function goToFirstPage() {
  return {
    type: GO_TO_FIRST_PAGE
  };
};
var goToLastPage = function goToLastPage() {
  return {
    type: GO_TO_LAST_PAGE
  };
};
var goToPage = function goToPage(pageNum) {
  return {
    type: GO_TO_PAGE,
    payload: {
      pageNum: pageNum
    }
  };
};
var ArrowsAndNumbers = function ArrowsAndNumbers(_ref) {
  var totNumItems = _ref.totNumItems,
    activePageNum = _ref.activePageNum,
    numItemsPerPage = _ref.numItemsPerPage,
    maxNumPagesToDisplay = _ref.maxNumPagesToDisplay,
    goToFirstPage = _ref.goToFirstPage,
    goToNextPage = _ref.goToNextPage,
    goToPrevPage = _ref.goToPrevPage,
    goToLastPage = _ref.goToLastPage,
    goToPage = _ref.goToPage;
  var totNumPages = Math.ceil(totNumItems / numItemsPerPage);
  var firstDisplayedPage = Math.max(Math.min(activePageNum - Math.floor(maxNumPagesToDisplay / 2), totNumPages - maxNumPagesToDisplay + 1), 1);
  var lastDisplayedPage = Math.min(totNumPages, firstDisplayedPage + maxNumPagesToDisplay - 1);
  var items = [];
  if (firstDisplayedPage > 1) {
    items.push(React.createElement(Pagination.Ellipsis, {
      onClick: function onClick() {
        return goToPage(firstDisplayedPage - 1);
      }
    }));
  }
  var _loop = function _loop(number) {
    items.push(React.createElement(Pagination.Item, {
      key: number,
      active: number === activePageNum,
      onClick: function onClick() {
        return goToPage(number);
      }
    }, number));
  };
  for (var number = firstDisplayedPage; number <= lastDisplayedPage; number++) {
    _loop(number);
  }
  return React.createElement('div', null, React.createElement(Pagination, {
    size: 'sm'
  }, React.createElement(Pagination.First, {
    onClick: goToFirstPage
  }), React.createElement(Pagination.Prev, {
    onClick: goToPrevPage
  }), items, React.createElement(Pagination.Next, {
    onClick: goToNextPage
  }), React.createElement(Pagination.Last, {
    onClick: goToLastPage
  })));
};
ArrowsAndNumbers.propTypes = {
  totNumItems: PropTypes.number.isRequired,
  activePageNum: PropTypes.number.isRequired,
  numItemsPerPage: PropTypes.number.isRequired,
  maxNumPagesToDisplay: PropTypes.number.isRequired,
  goToNextPage: PropTypes.func,
  goToPrevPage: PropTypes.func,
  goToFirstPage: PropTypes.func,
  goToLastPage: PropTypes.func,
  goToPage: PropTypes.func
};
var mapStateToProps$2 = function mapStateToProps(state) {
  return {
    totNumItems: getTotalNumItems(state),
    activePageNum: getActivePageNum(state),
    numItemsPerPage: getNumItemsPerPage(state),
    maxNumPagesToDisplay: getMaxNumPagesToDisplay(state)
  };
};
var ArrowsAndNumbers$1 = connect(mapStateToProps$2, {
  goToFirstPage: goToFirstPage,
  goToNextPage: goToNextPage,
  goToPrevPage: goToPrevPage,
  goToLastPage: goToLastPage,
  goToPage: goToPage
})(ArrowsAndNumbers);
var GotoPage = function GotoPage(_ref) {
  var totNumItems = _ref.totNumItems,
    numItemsPerPage = _ref.numItemsPerPage,
    goToPage = _ref.goToPage;
  var _useState = useState(undefined),
    _useState2 = slicedToArray(_useState, 2),
    activePageTmp = _useState2[0],
    setActivePageTmp = _useState2[1];
  var totNumPages = Math.ceil(totNumItems / numItemsPerPage);
  return React.createElement('div', null, 'Go to page:', React.createElement(Form, {
    onSubmit: function onSubmit(e) {
      return e.preventDefault();
    },
    inline: true
  }, React.createElement(Form.Group, null, React.createElement(FormControl, {
    type: 'text',
    autoComplete: 'off',
    size: 'sm',
    placeholder: '1..' + totNumPages,
    style: {
      maxWidth: '80px'
    },
    onInput: function onInput(event) {
      var pageNum = parseFloat(event.target.value);
      if (!event.target.value.includes(',') && !event.target.value.includes('.') && !isNaN(pageNum) && isFinite(pageNum) && pageNum > 0 && pageNum <= totNumPages) {
        setActivePageTmp(parseFloat(event.target.value));
      } else {
        setActivePageTmp(null);
      }
    },
    onKeyPress: function onKeyPress(target) {
      if (target.key === 'Enter') {
        goToPage(activePageTmp);
      }
    }
  }), React.createElement(Button, {
    variant: 'outline-primary',
    size: 'sm',
    onClick: function onClick() {
      goToPage(activePageTmp);
    }
  }, 'Go'))));
};
GotoPage.propTypes = {
  totNumItems: PropTypes.number.isRequired,
  numItemsPerPage: PropTypes.number.isRequired,
  goToPage: PropTypes.func
};
var mapStateToProps$1 = function mapStateToProps(state) {
  return {
    totNumItems: getTotalNumItems(state),
    numItemsPerPage: getNumItemsPerPage(state)
  };
};
var GotoPage$1 = connect(mapStateToProps$1, {
  goToPage: goToPage
})(GotoPage);
var NumItemsPerPage = function NumItemsPerPage(_ref) {
  var numItemsPerPage = _ref.numItemsPerPage,
    setNumItemsPerPage = _ref.setNumItemsPerPage;
  var _useState = useState(null),
    _useState2 = slicedToArray(_useState, 2),
    validationState = _useState2[0],
    setValidationState = _useState2[1];
  var _useState3 = useState(numItemsPerPage),
    _useState4 = slicedToArray(_useState3, 2),
    numItemsPerPageTmp = _useState4[0],
    setNumItemsPerPageTmp = _useState4[1];
  return React.createElement('div', null, React.createElement(Form, {
    onSubmit: function onSubmit(e) {
      return e.preventDefault();
    },
    inline: true
  }, React.createElement(FormGroup, {
    controlId: 'formValidationError2',
    validationState: validationState
  }, React.createElement(Form.Label, null, 'Items per page: \xA0'), React.createElement(FormControl, {
    type: 'text',
    autoComplete: 'off',
    maxLength: '3',
    size: 'sm',
    style: {
      maxWidth: '80px'
    },
    placeholder: numItemsPerPage,
    onInput: function onInput(event) {
      if (event.target.value !== '' && !isNaN(parseFloat(event.target.value)) && isFinite(event.target.value) && parseFloat(event.target.value) > 0) {
        setValidationState(null);
        setNumItemsPerPageTmp(parseFloat(event.target.value));
      } else if (event.target.value !== '') {
        setValidationState('error');
      } else {
        setValidationState(null);
      }
    },
    onKeyPress: function onKeyPress(target) {
      if (target.key === 'Enter') {
        setNumItemsPerPage(numItemsPerPageTmp);
      }
    }
  }), React.createElement(Button, {
    variant: 'outline-primary',
    size: 'sm',
    onClick: function onClick() {
      setNumItemsPerPage(numItemsPerPageTmp);
    }
  }, 'Refresh'))));
};
NumItemsPerPage.propTypes = {
  numItemsPerPage: PropTypes.number.isRequired,
  setNumItemsPerPage: PropTypes.func
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    numItemsPerPage: getNumItemsPerPage(state)
  };
};
var NumItemsPerPage$1 = connect(mapStateToProps, {
  setNumItemsPerPage: setNumItemsPerPage
})(NumItemsPerPage);
var PaginatedList = function PaginatedList(_ref) {
  var WrappedComponent = _ref.WrappedComponent,
    fetchItemsFnc = _ref.fetchItemsFnc,
    header = _ref.header,
    showNumItemsPerPage = _ref.showNumItemsPerPage,
    showTotalNumItems = _ref.showTotalNumItems,
    numItemsPerPageProp = _ref.numItemsPerPageProp,
    maxNumPagesToDisplayProp = _ref.maxNumPagesToDisplayProp;
  var dispatch = useDispatch();
  var activePageNum = useSelector(function (state) {
    return state.activePageNum;
  });
  var numItemsPerPage = useSelector(function (state) {
    return state.numItemsPerPage;
  });
  var maxNumPagesToDisplay = useSelector(function (state) {
    return state.maxNumPagesToDisplay;
  });
  var totNumElements = useSelector(function (state) {
    return state.totalNumItems;
  });
  var count = (activePageNum - 1) * numItemsPerPage;
  var limit = numItemsPerPage;
  var totNumPages = Math.ceil(totNumElements / numItemsPerPage);
  var query = useQuery(['items', {
    count: count,
    limit: limit
  }], function () {
    if (numItemsPerPage === numItemsPerPageProp && maxNumPagesToDisplay === maxNumPagesToDisplayProp) {
      return fetchItemsFnc(count, limit);
    } else {
      return {
        totNumItems: 0
      };
    }
  });
  if (query.isSuccess) {
    dispatch(setTotalNumItems(query.data.totNumItems));
  }
  useEffect(function () {
    dispatch(setNumItemsPerPage(numItemsPerPageProp));
  }, [numItemsPerPageProp]);
  useEffect(function () {
    dispatch(setMaxNumPagesToDisplay(maxNumPagesToDisplayProp));
  }, [maxNumPagesToDisplayProp]);
  return React.createElement('div', null, query.isLoading ? React.createElement(Spinner, {
    animation: 'grow'
  }) : React.createElement('div', null, totNumElements > 0 ? React.createElement('div', null, showTotalNumItems ? React.createElement(TotNumItems$1, null) : null, showNumItemsPerPage ? React.createElement('div', null, React.createElement(NumItemsPerPage$1, null), React.createElement('br', null)) : null, header !== undefined ? React.createElement(Header, {
    header: header
  }) : null, query.isSuccess ? React.createElement(ListGroup, null, [].concat(toConsumableArray(query.data.items)).map(function (item, index) {
    return React.createElement(ListGroupItem, {
      key: index
    }, React.createElement(WrappedComponent, {
      item: item
    }));
  })) : null, totNumPages > 1 ? React.createElement('div', null, React.createElement('br', null), React.createElement(ArrowsAndNumbers$1, null), React.createElement(GotoPage$1, null)) : null) : null));
};
PaginatedList.propTypes = {
  WrappedComponent: PropTypes.any.isRequired,
  fetchItemsFnc: PropTypes.func.isRequired,
  header: PropTypes.arrayOf(PropTypes.shape({
    colWidth: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired
  })),
  showNumItemsPerPage: PropTypes.bool,
  showTotalNumItems: PropTypes.bool,
  numItemsPerPageProp: PropTypes.number,
  maxNumPagesToDisplayProp: PropTypes.number
};
PaginatedList.defaultProps = {
  showNumItemsPerPage: false,
  showTotalNumItems: true
};
var initialState = {
  activePageNum: 1,
  numItemsPerPage: 10,
  maxNumPagesToDisplay: 5,
  totalNumItems: 0
};
var reducer = createReducer(initialState, {
  SET_NUM_ITEMS_PER_PAGE: function SET_NUM_ITEMS_PER_PAGE(state, action) {
    state.numItemsPerPage = action.payload.numItemsPerPage;
  },
  SET_MAX_NUM_PAGES_TO_DISPLAY: function SET_MAX_NUM_PAGES_TO_DISPLAY(state, action) {
    state.maxNumPagesToDisplay = action.payload.maxNumPagesToDisplay;
  },
  SET_TOTAL_NUM_ITEMS: function SET_TOTAL_NUM_ITEMS(state, action) {
    state.totalNumItems = action.payload.totalNumItems;
  },
  GO_TO_NEXT_PAGE: function GO_TO_NEXT_PAGE(state, action) {
    if (state.activePageNum < Math.ceil(state.totNumItems / state.numItemsPerPage)) {
      state.activePageNum = state.activePageNum + 1;
    }
  },
  GO_TO_PREV_PAGE: function GO_TO_PREV_PAGE(state, action) {
    if (state.activePageNum > 1) {
      state.activePageNum = state.activePageNum - 1;
    }
  },
  GO_TO_FIRST_PAGE: function GO_TO_FIRST_PAGE(state, action) {
    state.activePageNum = 1;
  },
  GO_TO_LAST_PAGE: function GO_TO_LAST_PAGE(state, action) {
    state.activePageNum = Math.ceil(state.totalNumItems / state.numItemsPerPage);
  },
  GO_TO_PAGE: function GO_TO_PAGE(state, action) {
    var pageNum = action.payload.pageNum;
    if (pageNum !== null && pageNum !== '') {
      if (pageNum > 0 && pageNum <= Math.ceil(state.totalNumItems / state.numItemsPerPage)) {
        state.activePageNum = pageNum;
      }
    }
  }
});
var withPaginatedList = function withPaginatedList(WrappedComponent, fetchItemsFnc, numItemsPerPage, maxNumPagesToDisplay, showNumItemsPerPage, showTotalNumItems, header) {
  var queryClient = new QueryClient();
  var store = createStore(reducer, applyMiddleware(thunk));
  return function () {
    return React.createElement(Provider, {
      store: store
    }, React.createElement(QueryClientProvider, {
      client: queryClient
    }, React.createElement(PaginatedList, {
      fetchItemsFnc: fetchItemsFnc,
      WrappedComponent: WrappedComponent,
      header: header,
      numItemsPerPageProp: numItemsPerPage,
      maxNumPagesToDisplayProp: maxNumPagesToDisplay,
      showNumItemsPerPage: showNumItemsPerPage,
      showTotalNumItems: showTotalNumItems
    })));
  };
};
withPaginatedList.propTypes = {
  WrappedComponent: PropTypes.any.isRequired,
  fetchItemsFnc: PropTypes.func.isRequired,
  numItemsPerPage: PropTypes.number,
  maxNumPagesToDisplay: PropTypes.number,
  showNumItemsPerPage: PropTypes.bool,
  header: PropTypes.arrayOf(PropTypes.shape({
    colWidth: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired
  })).isRequired
};
withPaginatedList.defaultProps = {
  numItemsPerPage: 10,
  maxNumPagesToDisplay: 5,
  showNumItemsPerPage: false
};
export { withPaginatedList as default };